import { SVGProps } from 'react';

const Power = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2v10m6.4-5.4a9 9 0 1 1-12.77.04"
    />
  </svg>
);
export default Power;
